module.exports = __webpack_public_path__ + "img/logo_headway.9afc7f49.svg";